import { useState } from 'react';

import VaultsPageContainer from '@/app/components/VaultsPageComponents/VaultsPageContainer';
import VaultsTable from '@/app/components/VaultsPageComponents/VaultsTable';
import { BASIS_TABS, RateBasis } from '@/app/shared/constants/vaults';
import { Tabs } from '@/app/shared/ui/Tabs';

const VaultsPage = () => {
  const [activeBasis, setActiveBasis] = useState<RateBasis>('current');

  return (
    <VaultsPageContainer
      tabs={
        <Tabs
          tabs={BASIS_TABS}
          activeTab={activeBasis}
          onTabChange={setActiveBasis}
          className='flex h-full items-end gap-5'
          tabClassName='-mb-px border-b-2 border-transparent pb-5 text-base leading-5 transition-colors'
          activeTabClassName='border-brand-1100 text-brand-1100'
          inactiveTabClassName='text-gray-400 hover:text-gray-50'
        />
      }
    >
      <VaultsTable activeBasis={activeBasis} />
    </VaultsPageContainer>
  );
};

export default VaultsPage;
